import SuspenseWrapper from '@src/components/suspenseWrapper';
import React, { lazy } from 'react';

const RouteLeavingGuard = lazy(() => import('../routeLeavingGuard'));
const LeavingStepDialog = lazy(() => import('../leavingStepDialog'));
const ResolveVolumeStatus = lazy(() => import('../resolveVolumeStatus'));
const PaymentPrompt = lazy(() => import('../paymentPrompt'));

interface Props {
  routeLeavingGuardWhen: boolean;
  markPageAsClean: () => void;
  showLeavingStepDialog: boolean;
  navigateToStep: (index: number) => void;
  leavingStepDialogNextIndex: number;
  closeLeavingStepDialog: () => void;
  markPageAllAsClean?: () => void;
}

const StepFormExtraComponents = ({
  routeLeavingGuardWhen,
  markPageAsClean,
  showLeavingStepDialog,
  navigateToStep,
  leavingStepDialogNextIndex,
  closeLeavingStepDialog,
  markPageAllAsClean
}: Props) => {
  return (
    <>
      <SuspenseWrapper returnNullErrorFallback>
        <RouteLeavingGuard when={routeLeavingGuardWhen} />
      </SuspenseWrapper>
      {showLeavingStepDialog && (
        <SuspenseWrapper returnNullErrorFallback>
          <LeavingStepDialog
            nextStep={leavingStepDialogNextIndex}
            handleDestructiveClick={navigateToStep}
            isOpen={showLeavingStepDialog}
            onDismiss={closeLeavingStepDialog}
          />
        </SuspenseWrapper>
      )}
      <SuspenseWrapper returnNullErrorFallback>
        <ResolveVolumeStatus />
      </SuspenseWrapper>
      <SuspenseWrapper returnNullErrorFallback>
        <PaymentPrompt markPageAsClean={markPageAllAsClean || markPageAsClean} />
      </SuspenseWrapper>
    </>
  );
};

export default StepFormExtraComponents;
